import { Injectable } from '@angular/core';
import { computed, signal } from '@angular/core';
import { MessageService } from '../../../Reusables/reusable-pages/messages/message.service';
import {
  INotificationReceiver
} from '../../../Reusables/reusable-pages/messages/messages.model';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { groupBy, uniqBy } from 'lodash-es';
import { UtilityService } from '../../../Services/utility.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  protected readonly _notifications = signal<INotificationReceiver[]>([]);
  readonly loadedNotifications = signal(false);
  readonly readMap = signal<{ [id: number]: true }>({});
  readonly notifications = computed(() => {
    const readMap = this.readMap();
    return uniqBy(this._notifications(), (i) => i.id).map((x) => ({
      ...x,
      read: x.read || readMap[x.id],
      _dateSent: x.createdOn.slice(0, 10),
    }));
  });
  readonly notificationGroups = computed(() => {
    return Object.entries(groupBy(this.notifications(), (i) => i._dateSent)).map(([date, listByDate]) => ({
      date,
      listByDate,
      titleGroup: Object.entries(groupBy(listByDate, (i) => i._title)).map(([_, listByTitle]) => ({
        title: listByTitle[0]._title,
        listByTitle,
      })),
    }));
  });
  readonly loading = signal(true);
  readonly showOnlyUnread = signal(true);
  // readonly showOnlyUnread = signal(false);
  readonly total = signal(0);
  readonly canLoadMore = computed<boolean>(() => this.notifications()?.length < this.total());

  protected readonly pageSize = signal(10);
  protected readonly pageNumber = signal(0);

  constructor(
    public mS: MessageService,
    public uS: UtilityService,
  ) {
    this.mS.newNotification$.subscribe((r) => {
      this._notifications.update((list) => [r, ...list]);
       
    });
  }

  async loadMore() {
    this.loading.set(true);
    this.loadedNotifications.set(true);
    this.pageNumber.update((num) => num + 1);
    try {
      const res = await lastValueFrom(
        this.mS.searchNotificationReceivers(
          {
            pageSize: this.pageSize(),
            assignedTo: environment.userName,
            pageNumber: this.pageNumber(),
            sortBy: 'createdOn',
            sortDirection: 'DESC',
            read: this.showOnlyUnread() ? false : null,
          },
          true,
        ),
      );
      this._notifications.update((list) => list.concat(res.content));
      this.total.set(res.totalElements);
    } catch (error) {
      throw error;
    }
    this.loading.set(false);
  }


  markAsUnread(notification: INotificationReceiver) {
    if (notification.read) return;
    this.readMap.update((mp) => {
      return { ...mp, [notification.id]: true };
    });
    lastValueFrom(this.mS.markAsRead(notification.id, notification));
  }

  toggleShowOnlyUnread(showOnlyUnread: boolean) {
    this.showOnlyUnread.set(showOnlyUnread);
    this.pageNumber.set(0);
    this._notifications.set([]);
    this.loadMore();
  }

}
